import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { MailWarning, Loader2 } from "lucide-react";

export default function VerifyBanner() {
  const { user } = useAuth();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  if (!user || user.email_verified) return null;

  const resend = async () => {
    setSending(true);
    try {
      await api.post("/auth/resend-verification");
      setSent(true);
      toast.success("Verification email sent — check your inbox.");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Couldn't send the email.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200" data-testid="verify-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center">
        <MailWarning className="h-4 w-4 text-amber-700 shrink-0" strokeWidth={1.75} />
        <span className="text-sm text-amber-900">
          Verify your email to unlock CV tailoring, cover letters and referral rewards. We sent a link to <strong>{user.email}</strong>.
        </span>
        <button
          onClick={resend}
          disabled={sending || sent}
          data-testid="resend-verification-button"
          className="text-sm font-semibold text-amber-900 underline underline-offset-2 hover:text-amber-950 disabled:opacity-60 inline-flex items-center gap-1.5"
        >
          {sending && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
          {sent ? "Email sent" : "Resend email"}
        </button>
      </div>
    </div>
  );
}
